import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/loginpage.css";

import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/img/gmt_logo2.png";

const BASE_URL = process.env.REACT_APP_API_BASE || "";

if (!BASE_URL) {
  console.warn("REACT_APP_API_BASE is not defined");
}

// SLIDES
import slide1 from "../../assets/img/login_page.png";
import slide2 from "../../assets/img/login_page2.png";
import slide3 from "../../assets/img/login_page3.png";

const SLIDES = [slide1, slide2, slide3];

export default function Login() {

    const navigate = useNavigate();
  const { login } = useAuth();

const handleForgotPassword = async () => {
  if (!forgotEmail) return;

  try {
    setForgotLoading(true);
    setForgotMsg("");

   const res = await fetch(`${BASE_URL}/auth/forgot-password.php`, {
  method: "POST",
  credentials: "include",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ email: forgotEmail }),
});

    const data = await res.json();

    if (!res.ok || !data.status) {
      throw new Error(data.message || "Unable to process request");
    }

    setForgotMsg(
      "If this email exists, a reset link has been sent."
    );
  } catch (err) {
    setForgotMsg(err.message || "Something went wrong. Try again.");
  } finally {
    setForgotLoading(false);
  }
};


const handleVerifyOTP = async () => {

  try {

    setOtpLoading(true);
    setOtpError("");

    const response = await fetch(
      `${BASE_URL}/auth/verify-otp.php`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          otp: otpCode,
        }),
      }
    );

    const result = await response.json();

    if (!response.ok || !result.status) {
      throw new Error(result.message || "Invalid code");
    }

    login(result.data);

    setShowOTP(false);

    navigate("/dashboard", {
      replace: true,
    });

  } catch (err) {

    setOtpError(
      err.message || "Verification failed"
    );

  } finally {

    setOtpLoading(false);

  }

};



  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [showForgot, setShowForgot] = useState(false);
const [forgotEmail, setForgotEmail] = useState("");
const [forgotLoading, setForgotLoading] = useState(false);
const [forgotMsg, setForgotMsg] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [toast, setToast] = useState(null);

  const [showOTP, setShowOTP] = useState(false);
const [otpCode, setOtpCode] = useState("");
const [otpLoading, setOtpLoading] = useState(false);
const [otpError, setOtpError] = useState("");


  // 🔁 AUTO SLIDE (FADE)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev =>
        prev === SLIDES.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
   const response = await fetch(`${BASE_URL}/auth/login.php`, {
  method: "POST",
  credentials: "include",   // 🔥 VERY IMPORTANT
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify(form),
});


    const result = await response.json();

    if (!response.ok || !result.status) {
      throw new Error(result.message || "Login failed");
    }

  login(result.data);
navigate("/dashboard", { replace: true });
return;

  } catch (err) {
    setError(err.message || "Invalid email or password");
  } finally {
    setLoading(false);
  }
};




  

  return (
    <div className="login-wrapper">

    {toast && (
  <div className="modern-toast">
    <div className="toast-icon success">
      ✓
    </div>

    <div className="toast-content">
      <p className="toast-title">Success</p>
      <p className="toast-message">{toast.message}</p>
    </div>
  </div>
)}



      {/* ================= LEFT FADE SLIDER ================= */}
      <div className="login-left">

        {/* SLIDE LAYERS */}
        {SLIDES.map((img, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}

        {/* PROMO CONTENT */}
        <div className="promo-card">
          <small>Secure • Fast • Reliable</small>
          <h1>
            GMT Technologies <br /> Admin Portal
          </h1>
          <p>
            Access HRM, CRM and Admin dashboards securely from one platform.
          </p>

          <div className="promo-stats">
            <div>
              <strong>99.9%</strong>
              <span>Uptime</span>
            </div>
            <div>
              <strong>24/7</strong>
              <span>Support</span>
            </div>
          </div>
        </div>

        {/* SLIDER DOTS */}
        <div className="slider-dots">
          {SLIDES.map((_, i) => (
            <span
              key={i}
              className={i === currentSlide ? "active" : ""}
            />
          ))}
        </div>
      </div>

      {/* ================= RIGHT FORM ================= */}
    <div className="login-right">

  <div className="top-logo">
    <img src={logo} alt="GMT Technologies" />
  </div>

  <div className="login-box">

          <h2>Sign In</h2>
          <p className="text-muted mb-4">
            Enter your credentials to continue
          </p>

          {error && (
            <div className="alert alert-danger py-2">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Email address</label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="you@gmt.com"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Password</label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control"
                  placeholder="••••••••"
                  value={form.password}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`bi ${
                      showPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  />
                </button>
              </div>
            </div>

            <div className="d-flex justify-content-between mb-4">
              <div>
                <input type="checkbox" /> Remember me
              </div>
            <span
  className="text-primary"
  style={{ cursor: "pointer" }}
  onClick={() => {
    setForgotMsg("");
    setForgotEmail("");
    setShowForgot(true);
  }}
>
  Forgot password?
</span>

            </div>

          <button
  type="submit"
  className="btn btn-primary w-100 py-2 login-btn"
  disabled={loading}
>
  {loading ? (
    <span className="login-spinner" />
  ) : (
    "Login"
  )}
</button>

          </form>

          <p className="text-center mt-4 text-muted" style={{ fontSize: 13 }}>
            © {new Date().getFullYear()} GMT Technologies Limited
          </p>
        </div>


        {/* ================= FORGOT PASSWORD MODAL ================= */}
{showForgot && (
  <div className="modal-backdrop-custom">
    <div className="modal-card-custom">

      {/* HEADER */}
      <div className="modal-header-custom">
        <div>
          <h5 className="modal-title">Reset Password</h5>
          <p className="modal-subtitle">
            Enter your email and we’ll send a secure reset link.
          </p>
        </div>

        <button
          className="modal-close-btn"
          onClick={() => setShowForgot(false)}
          aria-label="Close"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      {/* BODY */}
      <div className="modal-body-custom">

        {forgotMsg && (
          <div className="alert alert-info py-2 text-center">
            {forgotMsg}
          </div>
        )}

        <label className="form-label fw-semibold">
          Email address
        </label>
        <input
          type="email"
          className="form-control modal-input"
          placeholder="you@gmt.com"
          value={forgotEmail}
          onChange={e => setForgotEmail(e.target.value)}
        />

        <button
          className="btn btn-primary w-100 modal-primary-btn"
          disabled={forgotLoading}
          onClick={handleForgotPassword}
        >
          {forgotLoading ? "Sending..." : "Send Reset Link"}
        </button>

        <p className="modal-footer-text">
          If your email exists, you’ll receive a reset link shortly.
        </p>
      </div>
    </div>
  </div>
)}


{showOTP && (
  <div className="modal-backdrop-custom">
    <div className="modal-card-custom">

      <div className="modal-header-custom">
        <div>
          <h5 className="modal-title">
            Two-Factor Authentication
          </h5>

          <p className="modal-subtitle">
            Enter the verification code sent to your email.
          </p>
        </div>

        <button
          className="modal-close-btn"
          onClick={() => setShowOTP(false)}
        >
          ✕
        </button>
      </div>

      <div className="modal-body-custom">

        {otpError && (
          <div className="alert alert-danger">
            {otpError}
          </div>
        )}

        <label className="form-label fw-semibold">
          Verification Code
        </label>

       <input
  type="text"
  inputMode="numeric"
  maxLength="6"
  className="form-control modal-input"
  placeholder="Enter 6-digit code"
  value={otpCode}
  onChange={(e) =>
    setOtpCode(
      e.target.value.replace(/\D/g, "")
    )
  }
/>

        <button
          className="btn btn-primary w-100 modal-primary-btn mt-3"
          disabled={otpLoading}
          onClick={handleVerifyOTP}
        >
          {otpLoading
            ? "Verifying..."
            : "Verify & Login"}
        </button>

      </div>
    </div>
  </div>
)}

      </div>
    </div>
  );
}
